import { render, staticRenderFns } from "./SanRankingZhuZhuang.vue?vue&type=template&id=ec7e523c&scoped=true"
import script from "./SanRankingZhuZhuang.vue?vue&type=script&lang=js"
export * from "./SanRankingZhuZhuang.vue?vue&type=script&lang=js"
import style0 from "./SanRankingZhuZhuang.vue?vue&type=style&index=0&id=ec7e523c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7e523c",
  null
  
)

export default component.exports